import z from "zod";

/**
 * Формат email в реквизитах плательщика (спека §11, ORGANIZATION_BILLING_EMAIL_INVALID
 * на бэкенде): проверка на клиенте, чтобы админ увидел ошибку на поле сразу,
 * а не общим сообщением после отказа сервера. `.passthrough()`: остальные
 * поля формы (юрлицо, адрес, номер договора и т.д.) здесь не валидируются.
 *
 * `invoiceEmails` это TextArrayField (один Field на весь список чипов), у
 * него нет разметки под ошибку конкретного чипа, поэтому `refine` на весь
 * массив даёт одну строку сообщения на всё поле, а не zod `.email()` на
 * элемент, который вернул бы массив ошибок по индексам, который поле
 * показать не умеет.
 */
export function makeOrganizationBillingRequisitesValidationSchema() {
  return z
    .object({
      contactEmail: z
        .string()
        .optional()
        .refine(
          (value) => !value || z.email().safeParse(value).success,
          "Неверный формат email"
        ),
      invoiceEmails: z
        .array(z.string())
        .optional()
        .refine(
          (emails) =>
            (emails ?? []).every((email) => z.email().safeParse(email).success),
          "Каждый адрес должен быть в формате email"
        ),
    })
    .passthrough();
}
